export enum BeforeAfterPhotoType {
  AFTER = 'after',
  BEFORE = 'before'
}

export enum BeforeAfterMediaType {
  VIDEO = 'video',
  PHOTO = 'photo'
}
